import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";
import type { Tenant, Meta } from "../../lib/types";
import { Select } from "../core/Field";

export function useTenants(enabled = true) {
  return useQuery<Tenant[]>({ queryKey: ["tenants"], queryFn: async () => (await api.get("/tenants")).data, enabled });
}

export function useMeta() {
  return useQuery<Meta>({ queryKey: ["meta"], queryFn: async () => (await api.get("/vehicles/meta")).data, staleTime: Infinity });
}

export function TenantSelect({ value, onChange, allowAll = true, testId = "tenant-filter-select", className }: { value: string; onChange: (v: string) => void; allowAll?: boolean; testId?: string; className?: string }) {
  const { data } = useTenants();
  return (
    <Select data-testid={testId} value={value} onChange={(e) => onChange(e.target.value)} className={className}>
      {allowAll ? <option value="">All clients</option> : <option value="">Select client…</option>}
      {(data || []).map((t) => (
        <option key={t.id} value={t.id}>{t.name}{t.is_active ? "" : " (inactive)"}</option>
      ))}
    </Select>
  );
}
